import {
  PeopleTaggingChange,
  ReducerState,
} from '@components/asset/modal/tabs/edit/EditTabTypes';

const getPeopleTaggingChanges = (state: ReducerState): PeopleTaggingChange[] | false => {
  const changes = state.editState.peopleTaggingChanges;
  return changes && changes.length > 0 ? changes : false;
};

export default getPeopleTaggingChanges;
